import { mapServerToProductBase } from "./map-server-to-product-base.js";
import { mapServerToReadyReaderVariant } from "../../../../variant-mappers/mappers/server-to-client/variant-mappers/map-server-to-ready-reader-variant.js";
const mapServerToReadyReaderProduct = (serverProduct, slug, locale, facetConfigList, flatFacetConfigList, priceSegmentChannelKey) => {
  if (serverProduct?.__typename !== "ReadyReaderProduct") {
    return {
      failure: "incorrect-typename",
      message: `Expected ReadyReaderProduct for slug "${slug}", but got ${serverProduct?.__typename}`
    };
  }
  const variants = mapServerToReadyReaderVariant(
    serverProduct,
    slug,
    locale,
    priceSegmentChannelKey
  );
  if (!variants || variants.length === 0) {
    return {
      failure: "no-variants",
      message: `Cannot return Ready Reader product with slug: "${slug}" because it has no variants`
    };
  }
  return {
    ...mapServerToProductBase(serverProduct, variants, facetConfigList, flatFacetConfigList),
    productType: "Ready-readers",
    variants,
    isOfferedWithPrescriptions: false
  };
};
export {
  mapServerToReadyReaderProduct
};
//# sourceMappingURL=map-server-to-ready-reader-product.js.map
